import { marked } from 'marked'
import DOMPurify from 'dompurify'

/**
 * Parses markdown text to sanitized HTML with links opening in new tabs
 * @param {string} text - Markdown text to parse
 * @returns {string} Sanitized HTML string
 */
export function parseMarkdown(text) {
  if (!text) return '';
  if (typeof text !== 'string') {
    try {
      if (text && typeof text.text === 'string') {
        text = text.text;
      } else {
        text = JSON.stringify(text);
      }
    } catch (e) {
      text = String(text);
    }
  }
  
  const html = marked.parse(text);
  
  // Sanitize the HTML
  const sanitized = DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ALLOWED_TAGS: [
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'p', 'ul', 'ol', 'li', 'strong', 'em',
      'code', 'pre', 'blockquote', 'table',
      'thead', 'tbody', 'tr', 'th', 'td',
      'br', 'hr', 'a'
    ],
    ALLOWED_ATTR: ['class', 'href', 'target', 'rel']
  });

  // Process links to open in new tabs
  const div = document.createElement('div');
  div.innerHTML = sanitized;
  
  const links = div.querySelectorAll('a');
  links.forEach((link) => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });

  return div.innerHTML;
}
